import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function HomeFAQSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqKeys = [
    { q: 'home.faq.q1', a: 'home.faq.a1' },
    { q: 'home.faq.q2', a: 'home.faq.a2' },
    { q: 'home.faq.q3', a: 'home.faq.a3' },
    { q: 'home.faq.q4', a: 'home.faq.a4' },
    { q: 'home.faq.q5', a: 'home.faq.a5' },
    { q: 'home.faq.q6', a: 'home.faq.a6' },
    { q: 'home.faq.q7', a: 'home.faq.a7' },
    { q: 'home.faq.q8', a: 'home.faq.a8' },
  ];

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            speakable: {
              '@type': 'SpeakableSpecification',
              cssSelector: ['.faq-question', '.faq-answer'],
            },
            mainEntity: faqKeys.map((item) => ({
              '@type': 'Question',
              name: t(item.q),
              acceptedAnswer: {
                '@type': 'Answer',
                text: t(item.a),
              },
            })),
          }),
        }}
      />

      <section className="relative py-20 md:py-28 bg-background-50">
        <div className="max-w-[800px] mx-auto px-8">
          <div className="text-center mb-14">
            <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
              FAQ
            </p>
            <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-4">
              {t('home.faq.title')}
            </h2>
            <div className="gold-line mx-auto"></div>
          </div>

          <div className="space-y-3">
            {faqKeys.map((item, index) => (
              <div
                key={index}
                className="border border-background-200/60 bg-background-100/60"
              >
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left hover:bg-background-100/50 transition-colors duration-200"
                  aria-expanded={openIndex === index}
                >
                  <span className="faq-question font-heading text-[17px] text-foreground-900 tracking-[0.05em] pr-4">
                    {t(item.q)}
                  </span>
                  <span className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i
                      className={`text-sm text-accent-600 transition-transform duration-300 ${
                        openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                      }`}
                    ></i>
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-6 pb-5 pt-0">
                    <div className="border-t border-background-200/40 pt-4">
                      {String(t(item.a)).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="faq-answer text-[16px] text-foreground-700 leading-relaxed tracking-[0.03em]">{__s}</p>))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-10">
            <a
              href="/faq"
              className="inline-flex items-center gap-2 text-[15px] text-accent-600 hover:text-accent-500 transition-colors tracking-[0.06em]"
            >
              {t('home.faq.viewAll')}
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </section>
    </>
  );
}